import { render, staticRenderFns } from "./systemConfigSet.vue?vue&type=template&id=25e495c0"
import script from "./systemConfigSet.vue?vue&type=script&lang=ts"
export * from "./systemConfigSet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports